import { render, staticRenderFns } from "./TodoAssignmentOffer.vue?vue&type=template&id=6d31b231"
import script from "./TodoAssignmentOffer.vue?vue&type=script&lang=js"
export * from "./TodoAssignmentOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports